export interface ScopeOption {
  value: string;
  label: string;
  description?: string;
  recommended?: boolean;
}

export interface PricingScopeData {
  recommended_level: string;
  recommended_scope: string;
  target_id?: string;
  target_name?: string;
  level_options: ScopeOption[];
  scope_options: ScopeOption[];
  partner_groups?: Array<{ id: string; name: string }>;
}

export function isPricingScopeData(data: unknown): data is PricingScopeData {
  if (!data || typeof data !== "object") return false;
  const d = data as unknown as Record<string, unknown>;
  return (
    Array.isArray(d.level_options) &&
    Array.isArray(d.scope_options) &&
    d.level_options.length > 0
  );
}

/** Extract target name from structured_data — LLM may use different field names */
export function extractTargetName(data: PricingScopeData): string | null {
  if (data.target_name) return data.target_name;
  const d = data as unknown as Record<string, unknown>;
  if (typeof d.supplier === "string") return d.supplier;
  if (typeof d.partner_name === "string") return d.partner_name;
  if (typeof d.group_name === "string") return d.group_name;
  return null;
}

/** Extract recommended level — LLM may nest it differently */
export function extractRecommendedLevel(data: PricingScopeData): string {
  if (data.recommended_level) return data.recommended_level;
  const d = data as unknown as Record<string, unknown>;
  const rec = d.recommendation as Record<string, unknown> | undefined;
  if (rec && typeof rec.level === "string") return rec.level;
  const recommended = data.level_options.find(
    (o) => o.recommended || o.label.includes("recommand"),
  );
  return recommended?.value ?? "partner";
}

/** Extract recommended scope */
export function extractRecommendedScope(data: PricingScopeData): string {
  if (data.recommended_scope) return data.recommended_scope;
  const d = data as unknown as Record<string, unknown>;
  const rec = d.recommendation as Record<string, unknown> | undefined;
  if (rec && typeof rec.scope === "string") return rec.scope;
  const recommended = data.scope_options.find(
    (o) => o.recommended || o.label.includes("recommand"),
  );
  return recommended?.value ?? "company";
}
